<template>
  <tr data-test="horseRow">
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <td><slot name="selection" /></td>
      <td>
        {{ $t("people:ShoppingBasket.Payable.horse.label") }}
        <div v-if="item.paymentInProcess" class="secondary--text">
          {{
            $t(
              "people:ShoppingBasket.ShoppingBasketTab.InProcess.text",
              "In process",
              "Label of the order table section"
            )
          }}
        </div>
      </td>
      <td>
        <AppShowHorseWithDetails
          v-if="item.horse"
          :horse="item.horse"
          profile-link
        />
        <AppShowInputSkeleton
          v-if="item.payable.productParams"
          order-preset="productParams"
          :params="item.payable.productParams"
        />
        <slot name="notAllowedReasons" />
      </td>
      <td class="text-right"><slot name="price" /></td>
      <td><slot name="actions" /></td>
    </template>
    <template v-else>
      <td style="font-size: 12px" colspan="99">
        <v-row dense class="align-center">
          <v-col cols="1" class="mr-3">
            <slot name="selection" />
          </v-col>
          <v-col>
            <div>
              {{ $t("people:ShoppingBasket.Payable.horse.label") }}
            </div>
            <div v-if="item.paymentInProcess" class="secondary--text">
              {{
                $t(
                  "people:ShoppingBasket.ShoppingBasketTab.InProcess.text",
                  "In process",
                  "Label of the order table section"
                )
              }}
            </div>
          </v-col>
          <div>
            <slot name="price" />
          </div>
        </v-row>

        <v-row dense>
          <v-col>
            <AppShowHorseWithDetails
              v-if="item.horse"
              :horse="item.horse"
              profile-link
            />
            <AppShowInputSkeleton
              v-if="item.payable.productParams"
              order-preset="productParams"
              :params="item.payable.productParams"
            />

            <slot name="notAllowedReasons" />
          </v-col>
          <div class="pa-1 mt-2 d-flex justify-end">
            <slot name="actions" />
          </div>
        </v-row>
      </td>
    </template>
  </tr>
</template>
<script>
import AppShowHorseWithDetails from "@/components/elements/AppShows/horse/AppShowHorseWithDetails.vue";
import AppShowInputSkeleton from "@AppShows/AppShowInputSkeleton.vue";

export default {
  name: "HorseOrderDetails",
  components: {
    AppShowHorseWithDetails,
    AppShowInputSkeleton
  },
  inheritAttrs: false,
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>
